import store from '@/store'
import storage from 'store'
import { APP_LANGUAGE } from '@/store/mutation-types'
// import defaultSettings from '@/config/defaultSettings'

export default function Initializer () {
  // store.commit('SET_RESOLUTION', '640*360')
  store.dispatch('setLang', storage.get(APP_LANGUAGE, 'zh-CN'))
}
